import React, { useState, useRef, useEffect } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import axios from "axios";
import SideBar from "../SideBar";
import { baseUrl } from "../../../baseUrl";
import { useAuth } from "../../../AuthContext";
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from "react-router-dom";

const AddMaterial = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [active,setActive]=useState(false)
  const [message, setMessage] = useState(false);
  const [className, setClassName] = useState(null);
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [originalPrice, setOriginalPrice] = useState('');
  const [price, setPrice] = useState(null);
  const [file, setFile] = useState(null);
  const [imgFile, setImgFile] = useState(null);
  
  const fileRef = useRef();
  const imgFileRef = useRef();
  
  const data = { className, title, description, originalPrice, price,active };
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setMessage(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [message]);

  const handleSubmit = (e) => {
    if (className === null || className === "" || title === null || title === "" || description === null || originalPrice === "" || price === null || file === null || imgFile === null) {
      setMessage("Make sure you enter all fields");
    } else {
      const formData = new FormData();
      formData.append('file', file[0]);
      formData.append('imgFile', imgFile[0]);
      formData.append('data', JSON.stringify(data));
      axios
        .post(`${baseUrl}/material/add`, formData)
        .then((res) => {
          setMessage(res.data.message)
        })
        .catch((err) => console.log(err));
    }
  };

  const handleFile = (e) => {
    const validFileTypes = ['application/pdf'];
    const maxSizeInBytes = 2 * 1024 * 1024;
    if (validFileTypes.includes(e.target.files[0].type) &&
      e.target.files[0].size <= maxSizeInBytes) {
      setFile(e.target.files);
    } else {
      setMessage('Invalid file. Only PDF files under 2MB are allowed.');
      setFile(null);
      fileRef.current.value = "";
    }
  };

  const handleImgFile = (e) => {
    const validFileTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const maxSizeInBytes = 2 * 1024 * 1024;
    if (validFileTypes.includes(e.target.files[0].type) &&
      e.target.files[0].size <= maxSizeInBytes) {
      setImgFile(e.target.files);
    } else {
      setMessage('Invalid file. Only Image files (jpeg, jpg, png) under 2MB are allowed.');
      setImgFile(null);
      imgFileRef.current.value = "";
    }
  };

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        <div style={{ height: '30px' }} className="position-relative">
          {isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}
        </div>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to='/admin/materials' className="text-decoration-none">All Materials</Link>
              </li>
              <li className="breadcrumb-item active">
                Add Material
              </li>
            </div>
            <li className="nav-item dropdown">
              <span className="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="" role="button" aria-expanded="false">
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>

        <div className={`container ${styles.container}`}>
          <div className="bg-white p-4">
            <h4>Add Material</h4>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="title" className="form-label">Material Title</label>
                <input
                  type="text"
                  className="form-control"
                  id="title"
                  placeholder="Enter Material Title"
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="class" className="form-label">Select Class</label>
                <select
                  onChange={(e) => setClassName(e.target.value)}
                  className="form-select"
                  id="class"
                >
                  <option value="">Select class</option>
                  <option>Class XI</option>
                  <option>Class XII</option>
                  <option>Class XII Passed</option>
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="status" className="form-label">
                  Status :                   {
                    active ?
                      <label htmlFor="active" className="form-label">
                        Active
                      </label> :
                      <label htmlFor="inactive" className="form-label">
                        Inactive
                      </label>
                  }
                  <input checked={active} onChange={() => setActive(!active)} className="ml-2" type="checkbox" />
                </label>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-12">
                <label htmlFor="description" className="form-label">Description</label>
                <textarea
                  onChange={(e) => setDescription(e.target.value)}
                  className="form-control"
                ></textarea>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="originalPrice" className="form-label">Original Price (₹)</label>
                <input
                  type="number"
                  className="form-control"
                  id="originalPrice"
                  placeholder="Enter original price"
                  onChange={(e) => setOriginalPrice(e.target.value)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="price" className="form-label">Discounted Price (₹)</label>
                <input
                  type="number"
                  className="form-control"
                  id="price"
                  placeholder="Enter discounted price"
                  onChange={(e) => setPrice(e.target.value)}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="file" className="form-label">File</label>
                <input
                  id="file"
                  ref={fileRef}
                  onChange={handleFile}
                  type="file"
                  className="form-control"
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="imgFile" className="form-label">Image</label>
                <input
                  id="imgFile"
                  ref={imgFileRef}
                  onChange={handleImgFile}
                  type="file"
                  className="form-control"
                />
              </div>
            </div>

            {message && (
              <div className="alert alert-warning alert-dismissible fade show mt-3" role="alert">
                {message}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setMessage(false)}
                ></button>
              </div>
            )}

            <button onClick={handleSubmit} className="btn btn-primary mt-4">
              Add Material
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AddMaterial;
